// @ts-strict-ignore

import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { LMContextService, LMErrorUtilService, LMLoggerService, LMOverlayService } from '@app/services';
import { LMDialogButtonKey } from '@app/utils';
import { LMBuilderService, LMFacadeService } from '@app/components';
import { ListResource } from '@app/resources';

@Component({
  selector: 'lm-columnar-adhoc-report',
  standalone: false,
  templateUrl: './lm-columnar-adhoc-report.component.html',
  styleUrl: './lm-columnar-adhoc-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LMColumnarAdhocReportComponent implements OnInit, AfterViewInit, OnDestroy  {
  @HostBinding('attr.data-automation-id') automationId = 'lm-columnar-adhoc-report';

  @Input() listResource: ListResource | undefined;
  @Input() spec: LMListSpec | undefined;
  @Input() chartName: string | undefined;

  public isUpdated = false;
  public applyButtonLabel = Soho.Locale.translate(LMDialogButtonKey.APPLY);
  public cancelButtonLabel = Soho.Locale.translate(LMDialogButtonKey.CANCEL);
  public flyoutTitle = Soho.Locale.translate('BuildAdhocReport');

  public toolbarButtons: Array<LMToolbarButton> = [ ];
  private instanceId: string;

  public facadeDimensions: Array<LMFacadeField> = [];
  public facadeMeasures: Array<LMFacadeField> = [];
  public refreshTabPanels = false;
  private hasError = false;
  private errorMessage: string;

  constructor(
    private lmContextService: LMContextService,
    private lmLoggerService: LMLoggerService,
    private lmOverlayService: LMOverlayService,
    private lmFacadeService: LMFacadeService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmBuilderService: LMBuilderService,
    private changeDetectorRef: ChangeDetectorRef,
    ) {
    this.instanceId = this.lmLoggerService.instanceId;
  }

  ngOnInit() {
    const toolbarButton: LMToolbarButton = {
        id: 'adhoc-close-button',
        automationId: 'adhoc-close-button',
        state:           { visible: true, disabled: false },
        icon:            'close',
        isToggle:        false,
        actionReference: {
          "id": "StandardCloseOverlay",
          "automationId": "StandardCloseOverlay",
          "type": "standard",
          "tooltip": "Close",
          "icon": "close"
        }
      };
    this.toolbarButtons = [ toolbarButton ];
    this.lmFacadeService.getColumnarFacade(this.spec.busClassSpec.name).subscribe({
      next:  (columnarFacade)=> { this.handleFacadeResponse(columnarFacade);},
      error: (e)=> { this.handleError(e);}
    });

  }
  private handleFacadeResponse(columnarFacade: LMColumnarFacade){
    // TODO: Explicitly check for error here
    if (!columnarFacade.columnarDimensions) {
      this.handleError(columnarFacade as any);
      return;
    }
    this.facadeDimensions = columnarFacade.columnarDimensions;
    this.facadeMeasures = columnarFacade.columnarMeasures;
    this.refreshTabPanels = true;
    this.changeDetectorRef.markForCheck();
  }

  private handleError(e: any) {
    this.hasError = true;
    this.errorMessage = e.message;
    this.lmErrorUtilService.handleUnexpectedError(e);
  }

  ngAfterViewInit() {
    //if (this.lmContextService.useListFormOverlay()) {
      setTimeout(() => {
        this.lmOverlayService.busyIndicator(false);
      }, 10);
    //}
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent) {
    this.lmLoggerService.trace([ this, this.instanceId, 'onToolbarButtonEvent()', toolbarButtonEvent.actionReference ]);
    this.lmOverlayService.close();
  }

  public dimensionsUpdated(dimensions: LMAdhocAggField[]) {
    const chartSpec = this.spec.busListSpec.charts.find((c: LMChartSpec) => c.id === this.chartName);
    // Chart should exist, otherwise an error will be thrown before even the overlay comes up
    const measures: LMAdhocAggField[] = chartSpec.aggFields.filter((measure) => measure.isTotal);
    chartSpec.aggFields = [ ...dimensions, ...measures ];

    this.isUpdated = true;
    this.changeDetectorRef.markForCheck();
  }

    public measuresUpdated(measures: LMAdhocAggField[]) {
    const chartSpec = this.spec.busListSpec.charts.find((c: LMChartSpec) => c.id === this.chartName);
    // Chart should exist, otherwise an error will be thrown before even the overlay comes up
    const dimensions: LMAdhocAggField[] = chartSpec.aggFields.filter((field) => !field.isTotal);
    chartSpec.aggFields = [ ...dimensions, ...measures ];

    this.isUpdated = true;
    this.changeDetectorRef.markForCheck();
  }

  public onCancel() {
    this.lmOverlayService.close();
  }

  public onApply() {
    this.lmBuilderService.updateAdhocColumnarPersonalizationSpec(this.listResource, this.spec.userFolder, this.chartName, this.spec.busListSpec).subscribe({
      next: (v) => { this.handlePreviewAdhocColumnarResponse(v); },
      error: (e) => { this.handleError(e); }
    });
  }

  private handlePreviewAdhocColumnarResponse(response: LMBuilderUpdatePreviewResponse) {
    this.lmOverlayService.emitFlyoutContentEvent({ type: 'columnarAdhocSpec', payload: response });
    this.lmOverlayService.close();
  }
}
